module.exports = __webpack_public_path__ + "img/featuredartist (2).2ed34ad9.jpg";